import React, { useState, useEffect, useRef } from "react";
import { _getBaseUrl, _makeId, _isFirstRender } from "../utils/helper";
import { Radio } from "../forms";

const YearDropDown = ({ placeholder, ...props }) => {
  const dropdownRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const renderYears = (name, options) => {
    const s = parseInt(options.min);
    const e = parseInt(options.max);

    return (
      Array.from({ length: e - s + 1 }, (_, index) => {
        const year = s + index;
        return <Radio
          label={year}
          value={year}
          name={name}
          checked={props.value[name] == year ? true : false}
          onChange={() => onChangeHandler(name, year)}
        />;
      })
    )
  }

  const dropdownExpandHandler = () => {
    setIsExpanded(!isExpanded);
  };

  const onChangeHandler = (name, value) => {
    props.onChange(name, value);
  };

  return (
    <div className="filter-dropdown--wrapper relative" ref={dropdownRef}>
      <div
        className={`border border-black h-[70px] px-4 lg:px-5 flex items-center justify-between cursor-pointer ${props.toggleClass ? props.toggleClass : ''}`}
        onClick={() => dropdownExpandHandler()}
      >
        <span className="text-sm lg:text-base">{placeholder}</span>
        <img src={`${_getBaseUrl('src/assets/icon-download.svg', true)}`} alt="" className={`filter brightness-0 ${isExpanded ? 'rotate-180' : ''}`} />
      </div>
      {isExpanded && (
        <div className={`filter-dropdown--tray bg-white border border-black xl:border-t-0 md:absolute md:z-10 md:top-full md:left-0 p-5 ${props.trayClass ? props.trayClass : 'w-full'}`}>

          <div className={`h-full grid grid-cols-2 ${props.trayBodyClass ? props.trayBodyClass : ''}`}>
            <div>
              <div className="mb-3">From</div>
              <div className="overflow-y-auto pr-4 grid grid-cols-1 gap-2">
                {props.options !== undefined && (
                  renderYears('start_year', props.options)
                )}
              </div>
            </div>

            <div>
              <div className="mb-3">To</div>
              <div className="overflow-y-auto pr-4 grid grid-cols-1 gap-2">
                {props.options !== undefined && (
                  renderYears('end_year', props.options)
                )}
              </div>
            </div>
          </div>

        </div>
      )}
    </div>
  );
};

export default YearDropDown;
